import { useEffect } from 'react';

const useClickOutside = (ref: any, action: any) => {
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref && !ref.current.contains(event.target)) {
        action();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [action, ref]);
};
export default useClickOutside;
